import { useEffect, useState } from 'react'
import {
  getChurchHistoryData,
  getAncestorImageData,
  getCountryEventsData,
  getTimelineData,
  getRecipesData,
  getOrdinances,
} from './services'

export const useCountryFacts = ({ countryCode, getCountryFacts, which, globalDispatch }) => {
  useEffect(() => {
    if (countryCode && getCountryFacts) {
      getCountryFacts({ countryCode })
        .then((res) => {
          if (res.data) {
            globalDispatch({
              type: 'SET_HERITAGE_CONTENT',
              data: { content: res.data, which, noDataFound: false },
            })
          } else {
            globalDispatch({
              type: 'SET_HERITAGE_CONTENT',
              data: { content: {}, which, noDataFound: true },
            })
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            globalDispatch({
              type: 'SET_HERITAGE_CONTENT',
              data: { content: {}, which, noDataFound: true },
            })
          }
        })
    }
  }, [countryCode, getCountryFacts, globalDispatch, which])
}

export const useChurchHistoryData = ({ countryCode }) => {
  const [data, setData] = useState([])

  useEffect(() => {
    if (countryCode) {
      getChurchHistoryData({ countryCode }).then((results) => {
        setData(results)
      })
    }
  }, [countryCode])

  return data
}

export const useAncestorImageData = ({ personId, sessionId }) => {
  const [data, setData] = useState('')
  const [lastPersonId, setLastPersonId] = useState()

  // Prevent ancestor image from getting "stuck"
  useEffect(() => {
    if (personId !== lastPersonId) {
      setLastPersonId(personId)
      if (data) {
        setData('')
      }
    }
  }, [data, lastPersonId, personId])

  useEffect(() => {
    let subscribed = true
    const unsubscribe = () => {
      subscribed = false
    }
    if (personId && subscribed) {
      getAncestorImageData(personId, sessionId).then((results) => {
        if (results && results.link) {
          setData(results.link)
        }
      })
    }
    return () => unsubscribe()
  }, [personId, sessionId])

  return data
}

export const useCountryEventsData = (countryCodes) => {
  const [countryOneData, setCountryOneData] = useState()
  const [countryTwoData, setCountryTwoData] = useState()

  const codeOne = countryCodes[0]
  const codeTwo = countryCodes[1] ? countryCodes[1] : null

  useEffect(() => {
    if (codeOne) {
      getCountryEventsData(codeOne).then((results) => {
        setCountryOneData(results)
      })
    }

    if (codeTwo && codeOne !== codeTwo) {
      getCountryEventsData(codeTwo).then((results) => {
        setCountryTwoData(results)
      })
    }
  }, [codeOne, codeTwo])

  return [countryOneData, countryTwoData]
}

export const useTimelineEventsData = (sessionId) => {
  const [data, setData] = useState()

  useEffect(() => {
    getTimelineData().then((results) => {
      if (results) {
        setData(results)
      } else {
        setData([{ data: [] }, { data: [] }])
      }
    })
  }, [sessionId])

  return data
}

export const useRecipeData = ({ countryCode }) => {
  const [data, setData] = useState([])

  useEffect(() => {
    if (countryCode) {
      getRecipesData({ countryCode }).then((results) => {
        setData(results)
      })
    }
  }, [countryCode])

  return data
}

export const useOrdinances = ({ personId }) => {
  const [data, setData] = useState(null)

  useEffect(() => {
    getOrdinances({ personId }).then((results) => {
      setData(results)
    })
  }, [personId])

  return [data]
}
